import React, { Component } from "react";

import Button from "@material-ui/core/Button";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";

import { Link } from "react-router-dom";

import Logo from "../../assets/images/Лого/nume2.png";

import { firebase } from "../../firebase";

class Header extends Component {
  logoutHandler = () => {
    firebase
      .auth()
      .signOut()
      .then(
        () => {
          console.log("logged out");
        },
        error => {
          console.log("Error");
        }
      );
  };

  render() {
    const user = this.props.user;
    return (
      <AppBar
        style={{
          boxShadow: '0px 0px 7px 0px rgba(0,95,156,1)',
          position: "fixed",
          height: "120px"
        }}
      >
        <Toolbar
          style={{
            backgroundColor: "#d4ebff",
            position: "relative"
          }}
        >
          <div className="container" style={{
            maxWidth: '750px'
          }}>
            <div className="header_wrapper">
              <div className="header_logo">
                <div
                  style={{
                    background: `url(${Logo}) no-repeat center`,
                    backgroundSize: "contain",
                    width: "auto",
                    height: "160px",
                    margin: "0 auto",
                    position: 'relative',
                    top: '-20px'
                  }}
                />
              </div>

              <div className="header_menu">
                <div className="header_menu_top">
                  <span className="number">+37369902786</span>
                  <span style={{    fontSize: '16px',
    color:' #005f9cba'}}>Пн - Пт с 09:00 до 18:00</span>
                </div>

                <div className="header_menu_bottom">
                  <Link to="/">
                    <Button className="nav_links">Главная</Button>
                  </Link>

                  <Link to="/products/Продукты">
                    <Button className="nav_links">Товар</Button>
                  </Link>

                  <Link to="/contacts">
                    <Button className="nav_links">Контакты</Button>
                  </Link>

                  {user ? (
                    <Button
                      className="nav_links"
                      onClick={() => this.logoutHandler()}
                    >
                      Выйти
                    </Button>
                  ) : null}
                </div>
              </div>
            </div>
          </div>
        </Toolbar>
      </AppBar>
    );
  }
}

export default Header;
